import { Link, useRouteError } from 'react-router-dom'
import { Button } from '@/components/ui'
import { WarningIcon } from '@/icons'

export function RouteErrorBoundary() {
  const error = useRouteError() as Error & { status?: number; statusText?: string }
  const notFound = error?.status === 404

  return (
    <div className="min-h-screen bg-base flex items-center justify-center p-4">
      <div className="bg-surface rounded-lg p-8 max-w-md w-full text-center">
        <div className="text-red-500 mb-4">
          <WarningIcon className="w-16 h-16 mx-auto" />
        </div>
        <h1 className="text-xl font-bold text-primary mb-2">{notFound ? 'Page Not Found' : 'Something went wrong'}</h1>
        <p className="text-muted mb-6">
          {notFound ? "The page you're looking for doesn't exist." : error?.message || 'An unexpected error occurred.'}
        </p>
        <div className="flex gap-3 justify-center">
          <Button as={Link} to="/">
            Go Home
          </Button>
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </div>
      </div>
    </div>
  )
}
